/**
 * Inservice consent
 * Inservice consent API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@libs/services/auth-strategy';

// @ts-ignore
import { ConsentGroupDto } from '../model/consentGroupDto';
// @ts-ignore
import { ConsentGroupSignatureStatusDto } from '../model/consentGroupSignatureStatusDto';
// @ts-ignore
import { CreateConsentGroupDto } from '../model/createConsentGroupDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class ConsentGroupsManagementService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy, // Inject the strategy if provided
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * Add a document to a consent group
   * @param xTENANTID 
   * @param groupId 
   * @param documentId 
   */
  public async consentGroupManagementControllerAddDocumentToGroup(xTENANTID: string, groupId: string, documentId: string, ): Promise<ConsentGroupDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling consentGroupManagementControllerAddDocumentToGroup.');
    }
    if (groupId === null || groupId === undefined) {
      throw new Error('Required parameter groupId was null or undefined when calling consentGroupManagementControllerAddDocumentToGroup.');
    }
    if (documentId === null || documentId === undefined) {
      throw new Error('Required parameter documentId was null or undefined when calling consentGroupManagementControllerAddDocumentToGroup.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.put({
      url: `${this.configuration.basePath}/api/consent/consent/management/group/${this.configuration.encodeParam({name: "groupId", value: groupId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documents/${this.configuration.encodeParam({name: "documentId", value: documentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Create a new consent group
   * @param xTENANTID 
   * @param createConsentGroupDto 
   */
  public async consentGroupManagementControllerCreate(xTENANTID: string, createConsentGroupDto: CreateConsentGroupDto, ): Promise<ConsentGroupDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling consentGroupManagementControllerCreate.');
    }
    if (createConsentGroupDto === null || createConsentGroupDto === undefined) {
      throw new Error('Required parameter createConsentGroupDto was null or undefined when calling consentGroupManagementControllerCreate.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/consent/consent/management/group`,
        data: createConsentGroupDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Delete a consent group
   * @param xTENANTID 
   * @param id 
   */
  public async consentGroupManagementControllerDelete(xTENANTID: string, id: string, ): Promise<ConsentGroupDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling consentGroupManagementControllerDelete.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling consentGroupManagementControllerDelete.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.delete({
      url: `${this.configuration.basePath}/api/consent/consent/management/group/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get all consent groups
   * @param xTENANTID 
   */
  public async consentGroupManagementControllerFindAll(xTENANTID: string, ): Promise<Array<ConsentGroupDto>> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling consentGroupManagementControllerFindAll.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/consent/consent/management/group`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get consent group by key
   * @param xTENANTID 
   * @param key 
   */
  public async consentGroupManagementControllerFindByKey(xTENANTID: string, key: string, ): Promise<ConsentGroupDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling consentGroupManagementControllerFindByKey.');
    }
    if (key === null || key === undefined) {
      throw new Error('Required parameter key was null or undefined when calling consentGroupManagementControllerFindByKey.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/consent/consent/management/group/${this.configuration.encodeParam({name: "key", value: key, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Check consent group signature status for a user
   * @param xTENANTID 
   * @param key 
   * @param signedById 
   * @param signedByType 
   * @param userType User type (e.g. \&quot;patient\&quot;)
   * @param userId User ID to check signature status for
   */
  public async consentGroupManagementControllerGetSignatureStatus(xTENANTID: string, key: string, signedById: string, signedByType: string, userType: string, userId: string, ): Promise<ConsentGroupSignatureStatusDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling consentGroupManagementControllerGetSignatureStatus.');
    }
    if (key === null || key === undefined) {
      throw new Error('Required parameter key was null or undefined when calling consentGroupManagementControllerGetSignatureStatus.');
    }
    if (signedById === null || signedById === undefined) {
      throw new Error('Required parameter signedById was null or undefined when calling consentGroupManagementControllerGetSignatureStatus.');
    }
    if (signedByType === null || signedByType === undefined) {
      throw new Error('Required parameter signedByType was null or undefined when calling consentGroupManagementControllerGetSignatureStatus.');
    }
    if (userType === null || userType === undefined) {
      throw new Error('Required parameter userType was null or undefined when calling consentGroupManagementControllerGetSignatureStatus.');
    }
    if (userId === null || userId === undefined) {
      throw new Error('Required parameter userId was null or undefined when calling consentGroupManagementControllerGetSignatureStatus.');
    }

    let localVarQueryParameters: any = {};
    if (key !== undefined && key !== null) {
      localVarQueryParameters['key'] = key;
    }
    if (signedById !== undefined && signedById !== null) {
      localVarQueryParameters['signedById'] = signedById;
    }
    if (signedByType !== undefined && signedByType !== null) {
      localVarQueryParameters['signedByType'] = signedByType;
    }
    if (userType !== undefined && userType !== null) {
      localVarQueryParameters['userType'] = userType;
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters['userId'] = userId;
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/consent/consent/management/group/signature/status`,
        params: localVarQueryParameters,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Remove a document from a consent group
   * @param xTENANTID 
   * @param groupId 
   * @param documentId 
   */
  public async consentGroupManagementControllerRemoveDocumentFromGroup(xTENANTID: string, groupId: string, documentId: string, ): Promise<ConsentGroupDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling consentGroupManagementControllerRemoveDocumentFromGroup.');
    }
    if (groupId === null || groupId === undefined) {
      throw new Error('Required parameter groupId was null or undefined when calling consentGroupManagementControllerRemoveDocumentFromGroup.');
    }
    if (documentId === null || documentId === undefined) {
      throw new Error('Required parameter documentId was null or undefined when calling consentGroupManagementControllerRemoveDocumentFromGroup.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.delete({
      url: `${this.configuration.basePath}/api/consent/consent/management/group/${this.configuration.encodeParam({name: "groupId", value: groupId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documents/${this.configuration.encodeParam({name: "documentId", value: documentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
